import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { NeoPeriodicidadLineaDTO } from '../Model/neoPeriodicidadLineaDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL = environment.apiLocalUrl + 'neoPeriodicidadLinea';
@Injectable({
  providedIn: 'root',
})
export class PeriodicidadLineaService {
  constructor(private _http: HttpClient) {}

  savePeriodicidadLinea(
    periodicidadLinea: NeoPeriodicidadLineaDTO[]
  ): Observable<NeoPeriodicidadLineaDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<NeoPeriodicidadLineaDTO>(
      API_URL, periodicidadLinea, { headers: headers }
    ).pipe(catchError(HandleHttpError));
  }

  updatePeriodicidadLinea(
    periodicidadLinea: NeoPeriodicidadLineaDTO[]
  ): Observable<NeoPeriodicidadLineaDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.put<NeoPeriodicidadLineaDTO>(API_URL, periodicidadLinea, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
  getPeriodicidadesLineaPorIdParametrizacion(
    idParametrizacionLinea
  ): Observable<NeoPeriodicidadLineaDTO[]> {
    return this._http.get<NeoPeriodicidadLineaDTO[]>(
      `${API_URL}/parametrizacion/${idParametrizacionLinea}`
    ).pipe(catchError(HandleHttpError));
  }
}
